import HttpService from "./http.service";

class PaymentService extends HttpService {
    listPaymentGateways = () => this.getPaymentGateways("payment/retrievePaymentGatewayInfomation");
}

export default new PaymentService();